import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const API = process.env.REACT_APP_API_URL;

export default function Login() {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const submit = async () => {
    if (!phone || !password) return toast.error("Fill all fields");

    setLoading(true);

    try {
      const res = await fetch(`${API}/api/webapi/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          phoneNumber: phone,
          pwd: password,
        }),
      });

      const data = await res.json();

      if (!data.status) {
        toast.error(data.message);
        setLoading(false);
        return;
      }

      /* SAVE ADMIN TOKEN */
      localStorage.setItem("admin_token", data.value);

      navigate("/admin/dashboard");
    } catch (err) {
      console.log(err);
      toast.error("Server error");
    }

    setLoading(false);
  };

  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    if (token) {
      navigate("/admin/dashboard");
    }
  }, []);

  return (
    <div className="admin-login d-flex align-items-center justify-content-center">
      <div className="login-card">
        <div className="text-center mb-4">
          <img src="/logo.png" height="50" alt="logo" />
          <h4 className="mt-2">Admin Panel</h4>
          <small className="text-muted">Sign in to continue</small>
        </div>

        {/* PHONE */}
        <div className="input-group mb-3">
          <span className="input-group-text bg-white">
            <i className="bi bi-telephone"></i>
          </span>
          <input
            className="form-control"
            placeholder="Phone Number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>

        {/* PASSWORD */}
        <div className="input-group mb-3">
          <span className="input-group-text bg-white">
            <i className="bi bi-lock"></i>
          </span>
          <input
            type={show ? "text" : "password"}
            className="form-control"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <span
            className="input-group-text bg-white"
            style={{ cursor: "pointer" }}
            onClick={() => setShow(!show)}
          >
            <i className={`bi ${show ? "bi-eye-slash" : "bi-eye"}`}></i>
          </span>
        </div>

        {/* LOGIN BUTTON */}
        <button className="btn btn-gradient w-100 mb-3" onClick={submit}>
          {loading ? "Please wait..." : "Login"}
        </button>
      </div>
    </div>
  );
}
